import React from 'react';
import { Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import { GRID_SPACING } from '../../../util/constants';

export function NavigationBreadcrumbsBase(props: { crumbs: [string, string][] }) {
  return (
    <Breadcrumbs sx={{ mb: GRID_SPACING }}>
      {props.crumbs.map(([name, route]) => (
        <MuiLink to={route} component={RouterLink} key={`${name}-${route}`}>
          {name}
        </MuiLink>
      ))}
    </Breadcrumbs>
  );
}
